import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';

export default class SetupRoute extends Route {
  @service filters;

  templateName = 'base/setup';

  afterModel() {
    return this.filters.process.perform();
  }

  redirect(model) {
    if (!model.isDraft) {
      this.router.transitionTo(
        `${model.isApiTriggered ? 'broadcasts.broadcast' : 'campaigns.campaign'}.overview`,
        model,
      );
    }
  }
}
